import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DocsList } from 'apps/auth/components/common/components/DocsList/DocsList';
import { DocsListItem } from 'apps/auth/components/common/components/DocsList/DocsListItem';
import { DocsBitText, DocsIllustration, DocsTable, DocsTd, DocsTr } from 'apps/auth/components/common/components/DocsList/styles';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { Text } from 'apps/auth/components/common/Text/Text';
import BasePage from 'apps/auth/components/utils/BasePage';
import { HOW_TO_SEND_DOCS_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AUTH_PROFILE_GA_LIMITS, URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const AntifraudGTAmlLevelDocsPage = (props) => {
    const { profile_form: profileForm, backTo, notNowLink } = useExtra();
    const {
        notNow,
        income_limits_title,
        docsOr,
        amlLimitDocs1,
        amlLimitDocs3,
        amlLimitsResidence1,
        amlLimitsResidence2,
        amlLimitsResidence3,
        amlLimitsResidence4,
        residence_limits_title,
        chat_limits_title,
        chat_limits_preview,
        wait_limits_title,
        wait_limits_preview,
        chatTitle,
    } = usePageMessages();

    useEffect(() => {
        amplitude.getInstance().logEvent(HOW_TO_SEND_DOCS_SCREEN_SHOWN);
    }, []);

    const notNowButtonClick = (e) => {
        e?.preventDefault();
        props.toggleSpinner(true);
        window.location.href = notNowLink;
    };

    return (
        <CommonPage
            backUrl={backTo || AUTH_PROFILE_GA_LIMITS}
            showChat={false}
            hasBottomPanel
            rightHeaderComponent={
                notNow && notNowLink && <Button type="link" variant="tertiary" size="tight" caption={notNow} href={notNowLink} onClick={notNowButtonClick} />
            }
        >
            <DocsList>
                <DocsListItem title={residence_limits_title}>
                    <DocsTable>
                        <DocsTr>
                            <DocsTd>
                                <DocsIllustration>
                                    <img src={`${URL_IMAGES_I}/kyc-bank-doc.svg`} alt="kyc-bank-doc" />
                                </DocsIllustration>
                                <DocsBitText>{docsOr}</DocsBitText>
                            </DocsTd>
                            <DocsTd>
                                <DocsIllustration>
                                    <img src={`${URL_IMAGES_I}/kyc-home-doc.svg`} alt="" />
                                </DocsIllustration>
                            </DocsTd>
                        </DocsTr>
                        <DocsTr>
                            <DocsTd>
                                <Text variant={'paragraph'} indent={'16px'}>
                                    {amlLimitDocs1}
                                </Text>
                                <Text variant={'paragraph'}>{amlLimitsResidence2}</Text>
                            </DocsTd>
                            <DocsTd>
                                <Text variant={'paragraph'} indent={'16px'}>
                                    {amlLimitDocs3}
                                </Text>
                                <Text variant={'paragraph'}>{amlLimitsResidence4}</Text>
                            </DocsTd>
                        </DocsTr>
                    </DocsTable>
                </DocsListItem>
                <DocsListItem title={income_limits_title}>
                    <DocsTable>
                        <DocsTr>
                            <DocsTd>
                                <DocsIllustration>
                                    <img src={`${URL_IMAGES_I}/kyc-bank-doc.svg`} alt="" />
                                </DocsIllustration>
                                <DocsBitText>{docsOr}</DocsBitText>
                            </DocsTd>
                            <DocsTd>
                                <DocsIllustration>
                                    <img src={`${URL_IMAGES_I}/kyc-payslips.svg`} alt="" />
                                </DocsIllustration>
                            </DocsTd>
                        </DocsTr>
                        <DocsTr>
                            <DocsTd>
                                <Text variant={'paragraph'} indent={'16px'}>
                                    {amlLimitsResidence1}
                                </Text>
                            </DocsTd>
                            <DocsTd>
                                <Text variant={'paragraph'} indent={'16px'}>
                                    {amlLimitsResidence3}
                                </Text>
                            </DocsTd>
                        </DocsTr>
                    </DocsTable>
                </DocsListItem>
                <DocsListItem title={chat_limits_title}>
                    <p>{resolveArguments(chat_limits_preview, profileForm?.id)}</p>
                </DocsListItem>
                <DocsListItem title={wait_limits_title}>
                    <p>{wait_limits_preview}</p>
                </DocsListItem>
            </DocsList>
            <FixedBottomPanel isRightAligned>
                <Button caption={chatTitle} type={'link'} onClick={() => props.toggleChat(true)} />
            </FixedBottomPanel>
        </CommonPage>
    );
};

export default connect(null, { toggleChat })(BasePage(AntifraudGTAmlLevelDocsPage));
